import { Route, Routes } from "react-router-dom";
import THContent from "./function-components/THContent";
import HomeContent from "./function-components/Requestor/HomeContent";
import DLRequestor from "./function-components/Requestor/DLRequestor";
import { useSelector } from "react-redux";
import DLNavbar from "./function-components/DLNavbar";

const DeliveryLeadershipPages = () => {
  const track = useSelector((state) => state.adminUser.TrackAdminUsers);
  return (
    <>
      <DLNavbar />
      <Routes>
        <Route path="/TH" element={<THContent track= {track}/>} />
        <Route path="/requestor" element={<DLRequestor track= {track}/>} />
      </Routes>
    </>
  );
};

export default DeliveryLeadershipPages;
